import React from "react";

import {} from "../redux/actions";
import {
    selectAgendaItemDragging,
    selectAgendaItemPosition
} from "../redux/selectors";
import { connect } from "react-redux";
import TimeblockControl from "./TimeblockControl";
import TimeblockView from "./TimeblockView";
class Timeblocks extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            parentTrackIndex: false,
            childTrackIndex: false,
            agendaTimeBlockIndex: false,
            agendaTimeBlockRow: false
        };
    }
    render() {
        return (
            <React.Fragment>
                {new Array(this.props.rows).fill(true).map((e, i) => {
                    return new Array(this.props.weekCount * 7)
                        .fill(true)
                        .map((e, j) => {
                            return (
                                <React.Fragment key={j}>
                                    <TimeblockControl
                                        row={i}
                                        column={j + 1}
                                        index={j}
                                        setEventPosition={
                                            this.props.setEventPosition
                                        }
                                        parentTrackIndex={
                                            this.props.parentTrackIndex
                                        }
                                        childTrackIndex={
                                            this.props.childTrackIndex
                                        }
                                        type={this.props.type}
                                    />
                                    <TimeblockView
                                        row={i + 1}
                                        column={j + 1}
                                        index={j}
                                        parentTrackIndex={
                                            this.props.parentTrackIndex
                                        }
                                        childTrackIndex={
                                            this.props.childTrackIndex
                                        }
                                        type={this.props.type}
                                        agendaItemPosition={
                                            this.props.agendaItemPosition
                                        }
                                    />
                                </React.Fragment>
                            );
                        });
                })}
                {}
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return {
            agendaItemDragging: selectAgendaItemDragging(store),
            agendaItemPosition: selectAgendaItemPosition(store)
        };
    },
    {}
)(Timeblocks);
